import React, { Component } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import crypto from 'crypto';
import _ from 'lodash';
import Loading from '../../../views/Loading';
import { Grid, Col, Row } from 'react-bootstrap';
import { dominio } from "../../../routes_backend/routes.jsx";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";

import Card from '../../../components/Card/Card';



const myGrid = React.createRef();


class Interface extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',

      ots: '',
      gridData: [], // Para almacenar los datos del grid
      isLoading: false,
      source_grid: "",
      columnsDetalle: [
        { text: "OTs", datafield: "document", width: '14%', cellsalign: "center", editable: true },
        { text: "Requisicion", datafield: "folio_source", width: '10%', cellsalign: "center", editable: true },
        { text: "Creado Por", datafield: "create_by_description", width: '10%', cellsalign: "center" },
        { text: "Responsable", datafield: "responsible_description", width: '10%', cellsalign: "center" },
        { text: "Codigo Item", datafield: "item_code", width: '14%', cellsalign: "center" },
        { text: "Descripcion Item", datafield: "item_description", width: '40%', cellsalign: "center" },
        { text: "Cantidad", datafield: "qty", width: '14%', cellsalign: "center" },
      ],
    };
  }

  // Manejar el cambio en el campo de entrada de OT
  handleOtsChange = (e) => {
    this.setState({ ots: e.target.value });
  };

  handleOtsChangeSAP = (e) => {
    this.setState({ requiSAP: e.target.value });
  };


  // Función para procesar la OT
  handleProcessOT = async () => {
    const { ots } = this.state;

    if (!ots) {
      Swal.fire('Error', 'Por favor, ingrese un número de OT.', 'error');
      return;
    }

    try {
      this.setState({
        isLoading: true,

      });
      // const response = await fetch('http://190.56.9.222:7000/POSTOTsSAP', {
        const response = await fetch(`${dominio}/POSTOTsSAP`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ots }),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          title: 'Proceso Completo',
          text: result.message,
          icon: 'success',
        }).then(() => {
          this.dataDetalle();
        });
      } else {
        Swal.fire({
          title: 'Error',
          text: result.error || 'Ocurrió un error durante el procesamiento.',
          icon: 'error',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: `No se pudo conectar con el servidor: ${error.message}`,
        icon: 'error',
      });
    }
  };

  handleProcessOTSAP = async () => {
    const { requiSAP, ots } = this.state;
  
    if (!requiSAP) {
      Swal.fire('Error', 'Por favor, ingrese un número de OT.', 'error');
      return;
    }
  
    try {
      this.setState({
        isLoading: true,
      });
  
      const response = await fetch(`${dominio}/CargaOTsSAP`, {

        
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ requiSAP, ots }),
      });
  
      const result = await response.json();
      // console.log(result);
      // console.log(result.response_text);
      
      
  
      if (response.ok) {

        
        Swal.fire({
          title: 'Proceso Completo',
          text: result.message, // Mostrar el mensaje completo desde el backend
          icon: 'success',
        }).then(() => {
          this.dataDetalle();
        });
    
      } else {
        
        Swal.fire({
          title: 'Error',
          text: result.response_text || 'Ocurrió un error durante el procesamiento.',
          icon: 'error',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: `No se pudo conectar con el servidor: ${error.message}`,
        icon: 'error',
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };




  

  makeRandomString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  createHMACBase64Hash(data, secretKey, hashAlg = 'sha256') {
    return crypto.createHmac(hashAlg, secretKey).update(data).digest('base64');
  }

  createHMACAuthHeader(nonce, method, route, host, timespan, port, secretKey) {
    const payloadHeader = 'hawk.1.header';
    const macString = `${payloadHeader}\n${timespan}\n${nonce}\n${method}\n${route}\n${host}\n${port}\n\n\n`;
    return this.createHMACBase64Hash(macString, secretKey);
  }

  dataDetalle = async () => {
    const { ots } = this.state;
    try {
      const idApp = 'TLFmgX1Kuef4rsaNxk9z'; // Reemplaza con tu ID de aplicación
      const secretKey = '6UUfExSUYBHVyHzBXF4lortJfrpIL4UVdGBJBEMqN9zzOjsOsPGIiR8'; // Reemplaza con tu clave secreta
      const host = 'app.fracttal.com';
      const method = 'GET';
      const route = `/api/work_orders_movements/${ots}`;
      const timespan = Math.floor(Date.now() / 1000);
      const nonce = this.makeRandomString(5); // string 5 characters
      const port = 443;

      const authHeader = this.createHMACAuthHeader(nonce, method, route, host, timespan, port, secretKey);

      this.setState({
        isLoading: true,
        message: '',
        data_ot: [],
      });

      const response = await axios.get(
        `https://${host}${route}`,
        {
          headers: {
            Authorization: `Hawk id="${idApp}", ts="${timespan}", nonce="${nonce}", mac="${authHeader}"`,
          },
        }
      );

      console.log(response.data.data);

      let array_source = [];
      response.data.data.forEach((element) => {
        element.list_items.forEach((item) => {
          let array = [
            element.document,
            element.folio_source,
            element.create_by_description,
            element.responsible_description,
            item.code,
            item.items_description,
            item.qty,
          ];
          array_source.push(array);
        });
      });

      let temp_grid = {
        data: [],
        localdata: array_source,
        datafields: [
          { name: "document", type: "number", map: "0" },
          { name: "folio_source", type: "number", map: "1" },
          { name: "create_by_description", type: "string", map: "2" },
          { name: "responsible_description", type: "string", map: "3" },
          { name: "item_code", type: "string", map: "4" },
          { name: "item_description", type: "string", map: "5" },
          { name: "qty", type: "number", map: "6" },
        ],
        datatype: "array",
      };

      this.setState({
        isLoading: false,
        source_gridDetalle: new jqx.dataAdapter(temp_grid),
      });

    } catch (error) {
      console.error('Error fetching data:', error);
      this.setState({ message: 'Error al enviar la solicitud', isLoading: false });
    }
  };



  render() {
    const { ots, requiSAP, isLoading } = this.state;




    return (
      <div className="content" style={{ textAlign: 'center', alignItems: 'center' }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Interface Fracttal SAP"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                 
                    <div className="row">
                      <div className="col-sm-12" style={{ overflow: 'auto' }}>
                        <br />
                        <div className="row" style={style.row}>
                      <div className="row">
                        <div className="col-sm-12" style={{ overflow: 'auto' }}>
                          <div className="col-sm-12">
                          Carga Ordenes desde Fracttal
                            <input
                              type="text"
                              placeholder="Ingrese el número de OT"
                              value={ots}
                              onChange={this.handleOtsChange}
                              style={{ padding: '10px', marginBottom: '10px' }}
                            />
                            <br />
                            <button onClick={this.handleProcessOT} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                              Procesar OT
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                        <br />
                        {!_.isEmpty(this.state.source_gridDetalle) ? (
                          <div className="col-sm-12">
                            <br />
                            Detalle
                            <br />
                            <JqxGrid
                              ref={myGrid}
                              width={"100%"}
                              // height={"800px"}
                              autoheight={true}
                              columns={this.state.columnsDetalle}
                              source={this.state.source_gridDetalle}
                              // //autoheight={true}
                              filterable={true}
                              selectionmode={"singlerow"}
                              altrows={true}
                              columnsresize={true}
                              showtoolbar={true}
                              sortable={true}
                              // theme={"material"}
                              showgroupaggregates={true}
                              showstatusbar={true}
                              // showaggregates={true}
                              groupable={true}
                              groups={['folio_source']}
                              editable={true}

                            />
                            <br />

                            <br />
                            <div className="row" style={style.row}>
                      <div className="row">
                        <div className="col-sm-12" style={{ overflow: 'auto' }}>
                          <div className="col-sm-12">
                          Ingresa Orden por requisicion a SAP

                            <input
                              type="text"
                              placeholder="Ingrese el número de OT"
                              value={requiSAP}
                              onChange={this.handleOtsChangeSAP}
                              style={{ padding: '10px', marginBottom: '10px' }}
                            />
                            <br />
                            <button onClick={this.handleProcessOTSAP} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                              Procesar OT
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}



const style = {
  errorMessage: {
    fontWeight: 'bold',
    fontSize: '12px',
    height: '10px',
    color: 'red',
  },
  text: {
    textAlign: 'center',
    backgroundColor: '#dddddd',
    border: '2px solid',
    color: '#000',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  ColorCell: {
    textAlign: 'center',
    border: '2px solid',
    color: '#000',
    fontSize: '14px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
};
export default Interface;
